import { Container, Row, Col } from "react-bootstrap"
import MenuMarketplace from "../../components/menus/MenuMarketplace"
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'

export default function OperationOK() {
    const { t } = useTranslation()
    const [secondsLeft, setSecondsLeft] = useState(5)

    useEffect(() => {
        const countdownId = setInterval(() => {
            setSecondsLeft((prev) => (prev > 0 ? prev - 1 : 0))
        }, 1000)

        const timeoutId = setTimeout(() => {
            const message = { type: 'CARD_PAYMENT_RESULT', status: 'success' }

            if (window.opener && !window.opener.closed) {
                window.opener.postMessage(message, window.location.origin)
            }

            if (window.parent && window.parent !== window) {
                window.parent.postMessage(message, window.location.origin)
            }

            window.close()
        }, 5000)

        return () => {
            clearInterval(countdownId)
            clearTimeout(timeoutId)
        }
    }, [])

    return(
        <>
            <MenuMarketplace section='operation'/>
            <Container className="vh-100 d-flex justify-content-center align-items-center">
                <Row>
                    <Col className="d-flex flex-column justify-content-center align-items-center">
                        <img src="/images/operationOK.svg" alt="Operation OK" />
                        <h2 className="my-3">{t("global.operationOK")}</h2>
                        <p dangerouslySetInnerHTML={{ __html: t("global.operationOKphrase") }} className="text-center"/>
                        <p dangerouslySetInnerHTML={{ __html: t("global.operationOKphrase2") }} className="text-center"/>
                        <p className="text-center mt-2">Se cerrara automaticamente en {secondsLeft}s</p>
                    </Col>
                </Row>
            </Container>
        </>
    )
}